import { useMemo } from "react";
import PropTypes from "prop-types";

import Admin from "./Admin";
import Simple from "./Simple";

export const VARIANTS = {
  SIMPLE: "simple",
  ADMIN: "admin",
};

const MODES = {
  simple: Simple,
  admin: Admin,
};

const Tab = ({ variant = VARIANTS.SIMPLE, ...props }) => {
  const View = useMemo(() => MODES[variant], [variant]);
  return <View {...props} />;
};

Tab.propTypes = {
  variant: PropTypes.oneOf([VARIANTS.SIMPLE, VARIANTS.ADMIN]),
  tabsConfig: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.node.isRequired,
    }),
  ),
  activeTab: PropTypes.string,
  onChange: PropTypes.func,
  children: PropTypes.node,
};

Tab.defaultProps = {
  variant: VARIANTS.SIMPLE,
};

export default Tab;
